module.exports = __webpack_public_path__ + "static/media/mohamedsamir1495_contact.041b7168.jpg";